import { RouteConfig } from 'vue-router';
import Form from '@/views/layout/Form.vue';
import i18n from '@/i18n';

const routes: Array<RouteConfig> = [
  {
    path: 'enumeration',
    name: 'enumeration',
    component: Form,
    redirect: { name: 'enumeration-list' },
    meta: {
      session: true,
    },
    children: [
      {
        path: 'list',
        name: 'enumeration-list',
        component: () => import('@/views/enumeration/EnumerationList.vue'),
        meta: {
          header: {
            label: () => i18n.tc('enumeration.label', 2),
          },
        },
      },
      {
        path: 'create',
        name: 'enumeration-create',
        component: () => import('@/views/enumeration/EnumerationCreate.vue'),
        meta: {
          header: {
            route: { name: 'enumeration-list' },
            label: () =>
              i18n.t('title.create', [i18n.tc('enumeration.label', 2)]),
          },
        },
      },
      {
        path: 'edit/:id(\\d+)',
        name: 'enumeration-edit',
        component: () => import('@/views/enumeration/EnumerationEdit.vue'),
        meta: {
          header: {
            route: { name: 'enumeration-list' },
            label: () =>
              i18n.t('title.edit', [i18n.tc('enumeration.label', 2)]),
          },
        },
      },
    ],
  },
];

export default routes;
